import axios from 'axios';
import store from 'store';
import { getAuthToken, onLogout } from 'actions/auth';
import { logoutAsClient } from 'actions/connectAsClient';
import getEnvVariable from 'utils/env';

const reactAppApiUrl = getEnvVariable('REACT_APP_API_URL');
const reactAppApiNewUrl = getEnvVariable('REACT_APP_API_NEW_URL');

export const formatUrl = (path, params) => {
  let url = path;
  if (params) {
    Object.keys(params).forEach((name) => {
      let hasParams = url.indexOf('?');
      if (params[name]) {
        url = `${url}${hasParams === -1 ? '?' : '&'}${name}=${params[name]}`;
      }
    });
  }
  return url;
};

const request = async ({
  protectedRoute,
  method,
  url,
  newApi,
  responseType = 'json',
  data,
  params = {},
  returnFullResponse = false,
  axiosOptions
}) => {
  let options = {
    responseType,
    url: `${newApi ? reactAppApiNewUrl : reactAppApiUrl}${url}`,
    method,
    data,
    params,
    ...axiosOptions
  };

  if (protectedRoute) {
    let token = await getAuthToken();
    const clientToken = store.getState().auth.clientToken;
    if (clientToken) {
      token = clientToken;
    }
    if (!token) {
      console.error('Error getting token', url);
    } else {
      options.headers = {
        Authorization: `Token ${token}`
      };
    }
  }
  try {
    const response = await axios(options);
    if (returnFullResponse) {
      return response;
    }
    return response.data;
  } catch (err) {
    console.error('Error on the url', url);
    console.error(err);
    if (err.response) {
      if (err.response.status === 403) {
        store.dispatch(logoutAsClient());
        store.dispatch(onLogout());
      }
    }

    if (returnFullResponse) {
      return err.response;
    } else {
      return false;
    }
  }
};

export default request;
